module.exports = __webpack_public_path__ + "static/media/aat.5cb32b94.png";